import React from "react";
import FieldHeader from "./FieldHeader";

interface Colors {
  backgroundColor: string;
  textColor: string;
}

export interface InputProps {
  radioLabelStr;
  name: string;
  id: string;
  checked: boolean;
  color?: Colors;
  onChange: (arg: any) => any | void;
}

export interface RadioBoxProps {
  labelStr: string;
  tooltipStr: string;
  number: number;
  value?: string | number;
  inputs: InputProps[];
  extraCssClass?: string;
  type: "default" | "color";
}

function RadioBox({
  labelStr,
  tooltipStr,
  number,
  inputs,
  type,
  extraCssClass,
}: RadioBoxProps) {
  return (
    <FieldHeader
      number={number}
      title={labelStr}
      tooltipStr={tooltipStr}
      extraCssClass={`product-section-row flex-column align-items-start ${extraCssClass}`}
      element={
        <div className={"d-flex px-2 pt-2 flex-wrap"}>
          {inputs.map((input, index) => {
            if (type === "default") {
              return <SimpleRadio key={`${input.id}-${index}`} input={input} />;
            } else if (type === "color") {
              return <ColorRadio key={`${input.id}-${index}`} input={input} />;
            }
          })}
        </div>
      }
    />
  );
}

export default RadioBox;

interface SimpleRadioProps {
  input: InputProps;
}

function SimpleRadio({ input }: SimpleRadioProps) {
  return (
    <div className={"custom-checkbox-v2 mr-4"}>
      <input
        type="radio"
        name={input.name}
        id={input.id}
        checked={input.checked}
        onChange={input.onChange}
      />
      <label htmlFor={input.id}>{`${input.radioLabelStr}`}</label>
    </div>
  );
}

interface ColorRadioProps {
  input: InputProps;
}

function ColorRadio({ input }: ColorRadioProps) {
  return (
    <div
      className={`custom-checkbox-colors mr-2 mb-2 btn btn-light ${
        input.checked ? "border-primary text-primary" : ""
      }`}
      onClick={input.onChange}>
      <input
        type="radio"
        name={input.name}
        id={input.id}
        checked={input.checked}
        onChange={input.onChange}
      />
      <div
        style={{
          backgroundColor: input.color.backgroundColor,
        }}>
        <p
          style={{
            color: input.color.textColor,
          }}>
          T
        </p>
      </div>
      <label htmlFor={input.id}>{`${input.radioLabelStr}`}</label>
    </div>
  );
}
